/**
 * @description 导出自定义配置
 **/
 const config = {
  layout: 'vertical',
  donation: false,
  templateFolder: 'project',
  plugId:"hikabilljdmmojpdcabihefglkgggafb",
}
if (process.env.NODE_ENV != 'production') {
  // config.plugId = "dgbemdboohbecajjaajflhmhkgcologh"
  config.plugId = "hikabilljdmmojpdcabihefglkgggafb"
  // config.plugId = `agjkmneekhjbepdfhaobofffofldohbd`
}
//导出配置（以自定义配置为主）
module.exports = Object.assign({}, config)
